<a
  class="sidebar-link sidebar-link-user truncate"
  [routerLink]="settingsRoute()"
  routerLinkActive="active"
  (click)="onClick()"
>
  <div class="sidebar-link-image justify-center">
    <dojo-profile-avatar [size]="30" class="shrink-0" />
  </div>
  <span class="sidebar-link-text text-md truncate" [matTooltip]="user().fullName">{{ user().fullName }}</span>
</a>
